export default {

  SOCIAL_MEDIA: {
    FACEBOOK: "https://www.facebook.com/goroindonesia/",
    LINKEDIN: "https://www.linkedin.com/company/goroindonesia/",
    INSTAGRAM: "https://www.instagram.com/goroindonesia/",
    TIKTOK: "https://www.tiktok.com/@goroindonesia/",
    CAREERS: "https://www.linkedin.com/company/goroindonesia/jobs/",
    YOUTUBE: "https://www.youtube.com/@goroindonesia",
  },

  REGISTERED_ON: {
    KOMINFO: "https://pse.kominfo.go.id/tdpse-detail/11835",
    TSI_KAN: "https://layanan.kan.or.id/sertifikat/18303",
  },

  MAIL_TO: {
    SELL_MY_PROPERTY: "https://jual-bu.com/",
    CONTACT_US: "mailto:contact@goro.id",
    CUSTOMER_SUPPORT: "mailto:hello@goro.id",
    RECRUITMENT: "mailto:recruitment@goro.id"
  },

  WHATSAPP: {
    COMPLAIN_SERVICE: "https://wa.me/6285311111010",
    // Static fallback for pages without store/config access (e.g. VitePress
    // landing sites); the app itself uses src/helpers/support.js
    CUSTOMER_SUPPORT: "https://wa.me/6287889644676",
  },

  STORE: {
    GOOGLE_PLAY: "https://play.google.com/store/apps/details?id=com.goro.id",
    APP_STORE: "https://apps.apple.com/app/goro/id6457259937",
  },

  OFFICES: {
    GORO_BALI_OFFICE: "https://maps.app.goo.gl/ktmwpRpU8ym5zr1A6?g_st=ac",
    GORO_JAKARTA_OFFICE: "https://maps.app.goo.gl/U2VtUyMy2rVMtUDr6"
  },

  CONTACT_EMAIL: "contact@goro.id",
  CUSTOMER_EMAIL: "hello@goro.id",
  FAQ: "https://goro.tawk.help/",
  TELEGRAMS: {
    DEFAULT: "https://t.me/goroindonesia"
  },
  SANDBOX: "https://www.ojk.go.id/id/Fungsi-Utama/ITSK/Regulatory-Sandbox/Documents/Daftar%20Peserta%20Sandbox%20Posisi%20Desember%202024.pdf"
}
